import { BookingStatus } from "@app/core/booking/domain/model/booking-status";
import { Player } from "@app/core/match/domain/model/match-detail";

export class BookingDetail {
  constructor(
    readonly code: string,
    readonly date: Date,
    readonly duration_minutes: number,
    readonly club: string,
    readonly pista: string,
    readonly location: string,
    readonly booking_status: BookingStatus,
    readonly integrated: boolean,
    readonly players: Player[],
    readonly matchRequestStatMessageTitle: string | null,
  ) {}
}
